import {
    BodyWrapper,
    ButtonWrapper,
    LineWrapper,
    Title,
} from "./styles/SessionExpiredModal.styles";
import { IconWrapper } from "./SessionExpired.styles";
import PropTypes from "prop-types";

import Alert from "shared/components/utils/icons/Alert";
import Button from "shared/components/inputs/mui/Button";
import { Container } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Text from "shared/components/data-display/mui/Text";
import { useNavigate } from "react-router-dom";
import { useStylesForButton, useStylesForSessionExpiredDialog } from "shared/styles/makeStyles";

const SessionExpiredModal = (props) => {
    const classes = useStylesForSessionExpiredDialog();
    const buttonClasses = useStylesForButton();
    const navigate = useNavigate();

    const fontVariant = "small";
    const titleStyle = {
        color: globalThis.config.colors.gray3,
    };

    const handleClose = () => {
        let url = new URL(globalThis.location);
        let redirectTo = url.searchParams.get("redirectTo");
        const newLocation = JSON.parse(decodeURIComponent(redirectTo));

        navigate(newLocation, {
            replace: true,
            state: newLocation.state,
        });
    };

    return (
        <Modal
            onHide={handleClose}
            backdrop={globalThis.config.modal.static}
            keyboard={globalThis.config.modal.keyboard}
            centered
            size="m"
            show={props.show}
            className={classes.root}
            animation={false}
        >
            <Modal.Header>
                <IconWrapper>
                    <Alert size="25" viewBox="18" />
                </IconWrapper>
                <Modal.Title>
                    <Title>
                        <Text variant="xlargeBold">You've Been Logged Out</Text>
                    </Title>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <BodyWrapper>
                        <LineWrapper>
                            <Text variant={fontVariant} style={titleStyle}>
                                You have been logged out because your session
                                has expired.
                            </Text>
                        </LineWrapper>
                        <LineWrapper>
                            <Text variant={fontVariant} style={titleStyle}>
                                Please login to view this page.
                            </Text>
                        </LineWrapper>
                    </BodyWrapper>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <ButtonWrapper>
                    <Button
                        className={[
                            buttonClasses.button,
                            buttonClasses.primary,
                            buttonClasses.noMargin,
                        ]}
                        onClick={() => handleClose()}
                    >
                        Login
                    </Button>
                </ButtonWrapper>
            </Modal.Footer>
        </Modal>
    );
};

SessionExpiredModal.propTypes = {
    show: PropTypes.bool,
};

export default SessionExpiredModal;
